module.exports = __webpack_public_path__ + "static/img/logo.c56c03b9.svg";